import api from "./api";
import {iniciarRequisicao, logout} from "../helpers/index.js";
import {STATUS_HTTP} from "./statusHTTP";

export const buscarCompradores = async (params) => {
  const url = `/compradores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.compradores;
  }

  logout();
}

